import { Box, Flex, Icon, Select, Text } from '@chakra-ui/react'
import ArrowLeft from '../../components/Icon/ArrowLeft'
import ArrowRight from '../../components/Icon/ArrowRight'
import ControlList from './ControlList'
import { NumbProps, PropsArrow } from './types'
import colors from '../../config/theme/colors'

export default function Pagination({ control }: { control: ControlList<any> }) {
    const {
        onPrev,
        onNext,
        onPage,
        nextActive,
        prevActive,
        pagination,
        queries,
        onLimit
    } = control.usePagination()

    return (
        <Flex
            bg="white"
            border="2px solid"
            borderColor="base-3"
            marginTop="5"
            borderRadius="lg"
            justifyContent="space-between"
            px={6}
            py={1}
        >
            <Flex alignItems="center">
                <Text fontSize="sm" mr={2}>
                    Mostrando
                </Text>
                <Select
                    size="xs"
                    value={queries.limit as number}
                    onChange={ev => onLimit(ev.target.value)}
                >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </Select>
            </Flex>
            <Box display="flex" justifyContent="flex-end">
                <Arrow
                    orientation="left"
                    active={prevActive}
                    onClick={onPrev}
                />
                <Box
                    bg="white"
                    display="flex"
                    marginLeft={2}
                    rounded="lg"
                    alignItems="center"
                >
                    {Array.from(Array(pagination.pages)).map((_, i) => (
                        <Numb
                            key={i}
                            value={i + 1}
                            active={pagination.page === i + 1}
                            onClick={() => onPage(i + 1)}
                        />
                    ))}
                </Box>
                <Arrow
                    orientation="right"
                    active={nextActive}
                    onClick={onNext}
                />
            </Box>
        </Flex>
    )
}

function Numb({ active, value, onClick }: NumbProps) {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            cursor={active ? 'display' : 'pointer'}
            w="27px"
            h="27px"
            onClick={onClick}
            bg={active ? '#E5E7EB' : colors.white}
            color={colors.dark}
            rounded="full"
            fontSize="sm"
        >
            {value}
        </Box>
    )
}

function Arrow({ orientation, active, onClick }: PropsArrow) {
    return (
        <Box
            w="35px"
            h="35px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius="full"
            onClick={onClick}
            opacity={active ? '1' : '0.5'}
            cursor={active ? 'pointer' : 'auto'}
        >
            {orientation === 'left' && (
                <Icon as={ArrowLeft} fill={colors.dark} fontSize="sm" />
            )}
            {orientation === 'right' && (
                <Icon as={ArrowRight} fill={colors.dark} fontSize="sm" />
            )}
        </Box>
    )
}
